import cssUtil from 'gw-portals-util-js/CssUtil';

import template from 'text!./SimpleEdit.html';
import styles from './SimpleEdit-hashed.scss';

export default (function () {
    return {
        restrict: 'E',
        scope: {
            scheduledItem: '<',
            shouldShowErrors: '<'
        },
        template: cssUtil.hashTemplate(template, styles)
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/MobileViewGenerator/subdirectives/edit/SimpleEdit/SimpleEdit.js
// module id = 271
// module chunks = 0